import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pagetransitiondirectionoptions"
    }}>{`PageTransitionDirectionOptions`}</h1>
    <p>{`The page transition direction options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NOT_APPLICABLE`}</strong>{` = 1886670401`}</p>
      <p parentName="blockquote">{`Direction does not apply.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DOWN`}</strong>{` = 1181971556`}</p>
      <p parentName="blockquote">{`The top to bottom direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RIGHT_TO_LEFT`}</strong>{` = 1920232546`}</p>
      <p parentName="blockquote">{`The right to left direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEFT_DOWN`}</strong>{` = 1886669892`}</p>
      <p parentName="blockquote">{`The down and left direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEFT_UP`}</strong>{` = 1886669909`}</p>
      <p parentName="blockquote">{`The up and left direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEFT_TO_RIGHT`}</strong>{` = 1819570786`}</p>
      <p parentName="blockquote">{`The left to right direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RIGHT_DOWN`}</strong>{` = 1886671428`}</p>
      <p parentName="blockquote">{`The down and right direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RIGHT_UP`}</strong>{` = 1886671445`}</p>
      <p parentName="blockquote">{`The up and right direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UP`}</strong>{` = 1181971566`}</p>
      <p parentName="blockquote">{`The bottom to top direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`IN`}</strong>{` = 1768824864`}</p>
      <p parentName="blockquote">{`The inward direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`OUT`}</strong>{` = 1886670708`}</p>
      <p parentName="blockquote">{`The outward direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HORIZONTAL`}</strong>{` = 1752134266`}</p>
      <p parentName="blockquote">{`The horizontal direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`VERTICAL`}</strong>{` = 1986359924`}</p>
      <p parentName="blockquote">{`The vertical direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HORIZONTAL_IN`}</strong>{` = 1886668873`}</p>
      <p parentName="blockquote">{`The horizontal inward direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HORIZONTAL_OUT`}</strong>{` = 1886668879`}</p>
      <p parentName="blockquote">{`The horizontal outward direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`VERTICAL_IN`}</strong>{` = 1886672457`}</p>
      <p parentName="blockquote">{`The vertical inward direction.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`VERTICAL_OUT`}</strong>{` = 1886672463`}</p>
      <p parentName="blockquote">{`The vertical outward direction.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      